import { ArrayElement } from "../utilities/ArrayElement";

export const languages = ["en", "de"] as const;
export type LanguageCode = ArrayElement<typeof languages>;
